const baseEventHandler = require('./base');
const { get } = require('lodash');

// we are given access to base event handlers with 'baseEventHandler' via the q.defer({}) method used in async-loader.js
const EventHandlers = {
    handleChangeOnBusinessType(ev, element, ctx, ...elementNames) { 
        const page = get(ctx, 'form.activePage');
        const fields = get(ctx, 'data.fields');
        const bizType = get(fields, 'businessType.value');

        if (elementNames.length > 0) {
            if (bizType) {
                elementNames.forEach((elementName) => {
                    baseEventHandler.show(elementName, ctx);
                    ctx.dataActions.updateField(elementName, '');
                });
            } else {
                elementNames.forEach((elementName) => {
                    baseEventHandler.hide(elementName, ctx);
                });
            }
        }

        if (bizType === 'PROPRIETORSHIP' || bizType === 'INDIVIDUAL') {
            baseEventHandler.hide('businessEstablishedDate', ctx);
            baseEventHandler.hide('businessRegistrationNumber', ctx);
            baseEventHandler.disableValidations('businessEstablishedDate', ctx);
            baseEventHandler.disableValidations('businessCountryOfIncorporation', ctx);
            ctx.dataActions.updateFieldWithErrors('businessCountryOfIncorporation', []);
            if (bizType === 'PROPRIETORSHIP') {
                ctx.formActions.updateElementProperty(page, 'businessCountryOfIncorporation', 'floatingLabel', 'fields.businessCountryOfIncorporationOptional.placeholder');
                ctx.dataActions.updateField('businessCountryOfIncorporation', '');
                baseEventHandler.disableValidations('occupation', ctx);
                baseEventHandler.disableValidations('occupationIndustry', ctx);
            } else {
                baseEventHandler.hide('businessCountryOfIncorporation', ctx);

                // Show occupation and industry fields only for individual
                baseEventHandler.show('occupationSectionHeader', ctx);
                baseEventHandler.show('occupation', ctx);
                baseEventHandler.show('occupationIndustry', ctx);
                baseEventHandler.enableValidations('occupation', ctx);
                baseEventHandler.enableValidations('occupationIndustry', ctx);
            } 
        } else {
            baseEventHandler.enableValidations('businessCountryOfIncorporation', ctx);
            ctx.formActions.updateElementProperty(page, 'businessCountryOfIncorporation', 'floatingLabel', 'fields.businessCountryOfIncorporation.placeholder');
            baseEventHandler.enableValidations('businessEstablishedDate', ctx);
            ctx.dataActions.updateField('businessCountryOfIncorporation', ctx.content && ctx.content.countryCode);
            baseEventHandler.disableValidations('occupation', ctx);
            baseEventHandler.disableValidations('occupationIndustry', ctx);
        }
    }
};

module.exports = EventHandlers;
